/*-----------------------------------------------
 共通JS
-----------------------------------------------*/

$(function(){

// ページトップへ戻るのスクロール
  var $pagetop = $('#pageTop');

  $pagetop.hide();

  $(window).scroll(function(){
    if($(window).scrollTop() > 200){
      $pagetop.fadeIn();
    } else {
      $pagetop.fadeOut();
    }
  });

  $pagetop.click(function(){
    $('html,body').animate({scrollTop:0},1000);
    return false;
  });

// アンカーリンクを押すと、スクロール
  $('a[href^=#]:not([class*="modal"])').click(function() {
      var speed = 700;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
  });


  //高さ揃え
  $('.matchHeight').matchHeight();


  //スマホの時だけ電話が押せるように
  var ua = navigator.userAgent.toLowerCase();
  var isMobile = /iphone/.test(ua)||/android(.+)?mobile/.test(ua);

  if (!isMobile) {
      $('a[href^="tel:"]').on('click', function(e) {
      e.preventDefault();
    });
  }

});



//スマホメニュー
$(function(){
  var menu = $('#gnavi'), // メニューを指定
      menuBtn = $('.menu-trigger'), // メニューボタンを指定
      body = $(document.body),
      menuWidth = checkWidth();

  var initialWidth = menu.outerWidth();

  function checkWidth(){
    var controllable = menu.outerWidth();
    return controllable;
  }

  $(window).on('load resize', function(){
    menuWidth = checkWidth();
    // if(menuWifth < 1024){
    //   menu.hide();
    // }
  });


  // メニューボタンをクリックした時の動き
  menuBtn.on('click', function(){
    // body に open クラスを付与する
    body.toggleClass('open');
    $(this).toggleClass('active');
    menu.toggleClass('is-active');

    if(body.hasClass('open')){
      // open クラスが body についていたら
      $('html').css({'overflow-y': 'hidden'});

    } else {
      // open クラスが body についていなかったら
      $('html').css({'overflow-y': 'scroll'});
    }
  });

});
